export default {
  styleOverrides: {
    root: {
      backgroundColor: '#282C34'
    }
  }
}
